"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var common_1 = require("../../utils/common");

var createReducer_1 = require("./createReducer");

var datatableAction_1 = require("./datatableAction");

var defaultState = {
  route: undefined,
  isFetching: false,
  entities: undefined,
  total_size: undefined,
  criteria: {
    limit: 10,
    offset: 0,
    orderBy: 'asc'
  },
  error: undefined
};

var request = function request(state, action) {
  return __assign({}, state, {
    isFetching: true
  });
};

var success = function success(state, action) {
  return __assign({}, state, {
    isFetching: false,
    entities: action.data.data,
    total_size: action.data.total_size
  });
};

var failure = function failure(state, action) {
  return __assign({}, state, {
    isFetching: false,
    error: action.error
  });
};

var nextPage = function nextPage(state, action) {
  return __assign({}, state, {
    criteria: __assign({}, state.criteria, {
      offset: Math.min(state.criteria.offset + state.criteria.limit, state.total_size || 0)
    })
  });
};

var prevPage = function prevPage(state, action) {
  return __assign({}, state, {
    criteria: __assign({}, state.criteria, {
      offset: Math.max(state.criteria.offset - state.criteria.limit, 0)
    })
  });
};

var goToPage = function goToPage(state, action) {
  var offset = action.pageNumber * state.criteria.limit;
  return __assign({}, state, {
    criteria: __assign({}, state.criteria, {
      offset: common_1.range(0, state.total_size || 0)(offset)
    })
  });
};

var updateCriteria = function updateCriteria(state, action) {
  var _a;

  return __assign({}, state, {
    criteria: __assign({}, state.criteria, (_a = {}, _a[action.name] = action.value, _a))
  });
};

var sort = function sort(state, action) {
  return __assign({}, state, {
    criteria: __assign({}, state.criteria, {
      sortBy: action.sortBy,
      orderBy: action.orderBy
    })
  });
};

exports.datatableReducer = function (name) {
  var _a;

  var ACTION = datatableAction_1.PAGINATE_(name);
  return createReducer_1.createReducer(defaultState, (_a = {}, _a[ACTION.REQUEST] = request, _a[ACTION.SUCCESS] = success, _a[ACTION.FAILURE] = failure, _a[ACTION.NEXT_PAGE] = nextPage, _a[ACTION.PREV_PAGE] = prevPage, _a[ACTION.GO_TO_PAGE] = goToPage, _a[ACTION.UPDATE_CRITERIA] = updateCriteria, _a[ACTION.SORT] = sort, _a));
};